export const encode = locationInfo => {
  const {
    stateNonLower,
    dma,
    statecounty,
    statesubcounty,
    alphaZone,
    zip,
    city,
    county,
    subCounty,
    isMajorMarket,
    isValid
  } = locationInfo;
  if (isValid) {
    return ['US', stateNonLower, zip, statecounty, dma, statesubcounty, alphaZone, city, county, subCounty, isMajorMarket].join('|');
  }
  return '';
};
export const decodeAsAkami = locationString => {
  const location = decode(locationString);
  return {
    akamaidma: location.dma,
    akamaistatecounty: location.statecounty,
    akamaistatesubcounty: location.statesubcounty,
    akamaizip: location.zip,
    akamaizipcodeall: location.zip
  };
};
export const isComplete = locationString => {
  return locationString.split('|').length === 11;
};
export const decode = locationString => {
  if (locationString) {
    const [country, stateNonLower, zip, statecounty, dma, statesubcounty, alphaZone, city, county, subCounty, isMajorMarket] = locationString.split('|');
    return {
      zip,
      country,
      state: (stateNonLower || '').toLowerCase(),
      stateNonLower,
      statecounty,
      alphaZone,
      dma,
      statesubcounty,
      city,
      county,
      subCounty,
      isMajorMarket: isMajorMarket === 'true',
      isValid: true
    };
  }
  return {};
};